import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
// 英語だけはプログラムに同梱する（他の言語の翻訳ファイルの読み込みが遅い・失敗した時に英語で表示するため）
// 英語以外は public/locales/{言語}/translations.json から読み込む
import enTranslations from './locales/en/translations.json';

i18n
  .use(Backend)
  .use(initReactI18next)
  // 表示言語は Hp.js で決める（URLの言語 → 端末の言語）。i18nextの言語自動検出（LanguageDetector）は、
  // 前回の言語を localStorage から読み込んで Hp.js の決定を後から上書きすることがあるため使わない（2026-10-07）
  .init({
    lng: 'en', // Hp.js で言語が決まるまでの初期値（同梱の英語のため通信なし）
    fallbackLng: 'en', //デフォルト
    ns: ['translations'],
    defaultNS: 'translations',
    // 同梱した英語はそのまま使い、それ以外の言語はBackendで読み込む
    resources: {
      en: { translations: enTranslations },
    },
    partialBundledLanguages: true,
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    react: {
        useSuspense: false
    }
  });

export default i18n;
